import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import { useReadiedQuery } from "@itandi/tools/next";
import { parsePositiveInteger } from "@itandi/tools/vanilla";
import Link from "next/link";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { useCompanyVendors } from "~/hooks/useCompanyVendors";
import { PATH as COMPANY_VENDORS_PATH } from "~/pages/settings/company_vendors";
import SettingStyles from "../../SettingStyle.module.scss";
import { ConstructionItemSettingList } from "./ConstructionItemSettingList";

export function Page() {
	const { data: companyVendors } = useCompanyVendors().index();
	const vendorCompanyId = useReadiedQuery("vendorCompanyId", (q) => {
		const parsed = parsePositiveInteger(q);

		if (parsed === null) {
			throw new Error("Invalid Vendor Company ID");
		}

		return parsed;
	});

	if (companyVendors === null) {
		return null;
	}

	const vendorCompany =
		companyVendors.find(
			(company) => company.vendorCompany?.id === vendorCompanyId
		)?.vendorCompany ?? null;

	if (vendorCompany === null) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<div className={SettingStyles.BreadcrumbsBlock}>
					<Breadcrumbs
						items={[
							{
								as: Link,
								href: COMPANY_VENDORS_PATH,
								label: "提携中の施工会社一覧"
							},
							{ label: "工事単価一覧" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader title={`${vendorCompany.name} 工事単価一覧`} />
					<PanelBody>
						<ConstructionItemSettingList />
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
